import type { ReactElement } from "react";
import { Badge } from "@primitives/index";
import { useAuthConfig } from "./auth/authContext";

/**
 * Renders a quiet "QA" chip beside the wordmark when the runtime config
 * declares the QA environment. Returns null otherwise (production, or when
 * the `environment` field is absent).
 *
 * The chip is a signal, not an alarm: neutral tone, small, and visible on
 * every viewport class. The environment is read from runtime config because
 * one web image is promoted across environments; a build-time flag would
 * read identically everywhere.
 */
export function EnvironmentMarker(): ReactElement | null {
    const { environment } = useAuthConfig();
    if (environment !== "qa") {
        return null;
    }
    return (
        <Badge
            variant="neutral"
            size="sm"
            aria-label="QA environment"
            title="QA environment"
            data-environment-marker="qa"
        >
            QA
        </Badge>
    );
}
